import Queue from '@/shared/types/fulfilment/queue.type';
import Response from '@/shared/types/response';
import chunkArray from '@/shared/utils/chunkArray';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

type CancelQueuesProps = {
  body: Queue[];
  onUnauthorized?: () => void;
  onProgress?: (progress: number) => void;
};

const cancelQueues = async ({
  body,
  onUnauthorized,
  onProgress,
}: CancelQueuesProps) => {
  const token = getCookie('auth_token');
  const chunks = chunkArray(body, 5);

  const responses: Response<Partial<Queue>[]>[] = [];

  let finishedRequests = 0;
  const totalRequests = body.length;

  for (const chunk of chunks) {
    const promises = chunk.map((item) =>
      fetcher<Response<Partial<Queue>[]>>({
        url: `/fulfilment/queue/${item.fulfilment_queue_id}/cancel/`,
        method: 'PUT',
        token,
        onUnauthorized,
      }).catch((error) => {
        return { ...error, data: [item] } as Response<Partial<Queue>[]>;
      }),
    );

    const results = await Promise.allSettled(promises);

    results.forEach((result) => {
      finishedRequests++;
      if (onProgress) {
        onProgress((finishedRequests / totalRequests) * 100);
      }

      if (result.status === 'fulfilled') {
        responses.push(result.value);
      } else {
        console.error(
          'Error occurred in function "cancelQueues" in file "src/shared/api/fulfilment/queue/cancelQueues.ts":',
          result.reason,
        );
        responses.push(result.reason as Response<Queue[]>);
      }
    });
  }

  return responses;
};

export default cancelQueues;
